// Brazilian DDDs (area codes) with state mapping
// Format: 55 (Brazil country code) + DDD + phone number
export interface DDDEntry {
  code: string;
  state: string;
  region: string;
  cities: string;
}

export const BRAZIL_DDDS: DDDEntry[] = [
  { code: '11', state: 'SP', region: 'Grande São Paulo', cities: 'São Paulo, Guarulhos, Osasco, Santo André' },
  { code: '12', state: 'SP', region: 'Vale do Paraíba', cities: 'São José dos Campos, Taubaté, Jacareí' },
  { code: '13', state: 'SP', region: 'Baixada Santista', cities: 'Santos, São Vicente, Guarujá' },
  { code: '14', state: 'SP', region: 'Bauru', cities: 'Bauru, Marília, Jaú, Botucatu' },
  { code: '15', state: 'SP', region: 'Sorocaba', cities: 'Sorocaba, Itapetininga, Tatuí' },
  { code: '16', state: 'SP', region: 'Ribeirão Preto', cities: 'Ribeirão Preto, Araraquara, São Carlos' },
  { code: '17', state: 'SP', region: 'São José do Rio Preto', cities: 'SJ Rio Preto, Catanduva, Votuporanga' },
  { code: '18', state: 'SP', region: 'Presidente Prudente', cities: 'Presidente Prudente, Araçatuba, Birigui' },
  { code: '19', state: 'SP', region: 'Campinas', cities: 'Campinas, Piracicaba, Limeira, Americana' },
  { code: '21', state: 'RJ', region: 'Grande Rio', cities: 'Rio de Janeiro, Niterói, Duque de Caxias, Nova Iguaçu' },
  { code: '22', state: 'RJ', region: 'Campos / Região dos Lagos', cities: 'Campos, Macaé, Cabo Frio, Búzios' },
  { code: '24', state: 'RJ', region: 'Volta Redonda', cities: 'Volta Redonda, Petrópolis, Teresópolis' },
  { code: '27', state: 'ES', region: 'Grande Vitória', cities: 'Vitória, Vila Velha, Serra, Cariacica' },
  { code: '28', state: 'ES', region: 'Cachoeiro de Itapemirim', cities: 'Cachoeiro, Colatina, Linhares' },
  { code: '31', state: 'MG', region: 'Grande BH', cities: 'Belo Horizonte, Contagem, Betim' },
  { code: '32', state: 'MG', region: 'Juiz de Fora', cities: 'Juiz de Fora, Barbacena, Muriaé' },
  { code: '33', state: 'MG', region: 'Governador Valadares', cities: 'Governador Valadares, Teófilo Otoni' },
  { code: '34', state: 'MG', region: 'Uberlândia', cities: 'Uberlândia, Uberaba, Araguari' },
  { code: '35', state: 'MG', region: 'Poços de Caldas', cities: 'Poços de Caldas, Pouso Alegre, Varginha' },
  { code: '37', state: 'MG', region: 'Divinópolis', cities: 'Divinópolis, Itaúna, Formiga' },
  { code: '38', state: 'MG', region: 'Montes Claros', cities: 'Montes Claros, Diamantina, Pirapora' },
  { code: '41', state: 'PR', region: 'Grande Curitiba', cities: 'Curitiba, São José dos Pinhais, Colombo' },
  { code: '42', state: 'PR', region: 'Ponta Grossa', cities: 'Ponta Grossa, Guarapuava, Irati' },
  { code: '43', state: 'PR', region: 'Londrina', cities: 'Londrina, Apucarana, Arapongas' },
  { code: '44', state: 'PR', region: 'Maringá', cities: 'Maringá, Umuarama, Cianorte, Paranavaí' },
  { code: '45', state: 'PR', region: 'Foz do Iguaçu', cities: 'Foz do Iguaçu, Cascavel, Toledo' },
  { code: '46', state: 'PR', region: 'Francisco Beltrão', cities: 'Francisco Beltrão, Pato Branco' },
  { code: '47', state: 'SC', region: 'Joinville', cities: 'Joinville, Blumenau, Itajaí, Jaraguá do Sul' },
  { code: '48', state: 'SC', region: 'Grande Florianópolis', cities: 'Florianópolis, São José, Criciúma, Tubarão' },
  { code: '49', state: 'SC', region: 'Chapecó', cities: 'Chapecó, Joaçaba, Lages, Caçador' },
  { code: '51', state: 'RS', region: 'Grande Porto Alegre', cities: 'Porto Alegre, Canoas, Novo Hamburgo, Gravataí' },
  { code: '53', state: 'RS', region: 'Pelotas', cities: 'Pelotas, Rio Grande, Bagé' },
  { code: '54', state: 'RS', region: 'Caxias do Sul', cities: 'Caxias do Sul, Passo Fundo, Bento Gonçalves, Erechim' },
  { code: '55', state: 'RS', region: 'Santa Maria', cities: 'Santa Maria, Uruguaiana, Alegrete, Cruz Alta' },
  { code: '61', state: 'DF/GO', region: 'Brasília e Entorno', cities: 'Brasília, Águas Claras, Taguatinga, Luziânia' },
  { code: '62', state: 'GO', region: 'Goiânia', cities: 'Goiânia, Anápolis, Aparecida de Goiânia' },
  { code: '63', state: 'TO', region: 'Palmas', cities: 'Palmas, Araguaína, Gurupi' },
  { code: '64', state: 'GO', region: 'Rio Verde', cities: 'Rio Verde, Catalão, Jataí, Caldas Novas' },
  { code: '65', state: 'MT', region: 'Cuiabá', cities: 'Cuiabá, Várzea Grande, Rondonópolis' },
  { code: '66', state: 'MT', region: 'Rondonópolis', cities: 'Rondonópolis, Sinop, Barra do Garças' },
  { code: '67', state: 'MS', region: 'Campo Grande', cities: 'Campo Grande, Dourados, Três Lagoas' },
  { code: '68', state: 'AC', region: 'Rio Branco', cities: 'Rio Branco, Cruzeiro do Sul' },
  { code: '69', state: 'RO', region: 'Porto Velho', cities: 'Porto Velho, Ji-Paraná, Ariquemes' },
  { code: '71', state: 'BA', region: 'Grande Salvador', cities: 'Salvador, Lauro de Freitas, Camaçari' },
  { code: '73', state: 'BA', region: 'Ilhéus', cities: 'Ilhéus, Itabuna, Porto Seguro, Eunápolis' },
  { code: '74', state: 'BA', region: 'Juazeiro', cities: 'Juazeiro, Jacobina, Irecê' },
  { code: '75', state: 'BA', region: 'Feira de Santana', cities: 'Feira de Santana, Alagoinhas, Serrinha' },
  { code: '77', state: 'BA', region: 'Vitória da Conquista', cities: 'Vitória da Conquista, Barreiras, Brumado' },
  { code: '79', state: 'SE', region: 'Aracaju', cities: 'Aracaju, Nossa Senhora do Socorro, Lagarto' },
  { code: '81', state: 'PE', region: 'Grande Recife', cities: 'Recife, Olinda, Jaboatão, Caruaru' },
  { code: '82', state: 'AL', region: 'Maceió', cities: 'Maceió, Arapiraca, Rio Largo' },
  { code: '83', state: 'PB', region: 'João Pessoa', cities: 'João Pessoa, Campina Grande, Patos' },
  { code: '84', state: 'RN', region: 'Natal', cities: 'Natal, Mossoró, Parnamirim' },
  { code: '85', state: 'CE', region: 'Grande Fortaleza', cities: 'Fortaleza, Caucaia, Maracanaú, Sobral' },
  { code: '86', state: 'PI', region: 'Teresina', cities: 'Teresina, Parnaíba, Picos' },
  { code: '87', state: 'PE', region: 'Petrolina', cities: 'Petrolina, Garanhuns, Serra Talhada' },
  { code: '88', state: 'CE', region: 'Juazeiro do Norte', cities: 'Juazeiro do Norte, Crato, Iguatu' },
  { code: '89', state: 'PI', region: 'Picos', cities: 'Picos, Floriano, São Raimundo Nonato' },
  { code: '91', state: 'PA', region: 'Grande Belém', cities: 'Belém, Ananindeua, Castanhal' },
  { code: '92', state: 'AM', region: 'Manaus', cities: 'Manaus, Itacoatiara, Parintins' },
  { code: '93', state: 'PA', region: 'Santarém', cities: 'Santarém, Altamira, Itaituba' },
  { code: '94', state: 'PA', region: 'Marabá', cities: 'Marabá, Parauapebas, Tucuruí' },
  { code: '95', state: 'RR', region: 'Boa Vista', cities: 'Boa Vista, Rorainópolis' },
  { code: '96', state: 'AP', region: 'Macapá', cities: 'Macapá, Santana' },
  { code: '97', state: 'AM', region: 'Coari', cities: 'Coari, Tefé, Tabatinga' },
  { code: '98', state: 'MA', region: 'Grande São Luís', cities: 'São Luís, Imperatriz, São José de Ribamar' },
  { code: '99', state: 'MA', region: 'Imperatriz', cities: 'Imperatriz, Caxias, Timon, Bacabal' },
];

export const DEFAULT_DDD = '54';

/**
 * Normalize a Brazilian phone number:
 * - 12-13 digits (already 55 + DDD + number): return as-is
 * - 10-11 digits (DDD + number, no country code): prepend 55
 * - 8-9 digits (local number only): prepend 55 + DDD
 * - shorter: return as-is (invalid)
 */
export function normalizeBrazilianPhone(phone: string, ddd: string = DEFAULT_DDD): string {
  const digits = phone.replace(/\D/g, '');

  if (digits.length >= 12) {
    // Already has country code (55) + DDD + number
    return digits;
  }

  if (digits.length >= 10) {
    // Has DDD + number, add country code
    return '55' + digits;
  }

  if (digits.length >= 8) {
    // Only local number, add country code + DDD
    return '55' + ddd + digits;
  }

  // Too short, probably invalid — return as-is
  return digits;
}

/**
 * Check if a Brazilian phone number is missing the country code prefix
 */
export function isMissingBrazilianCountryCode(phone: string): boolean {
  const digits = phone.replace(/\D/g, '');
  return digits.length >= 8 && digits.length < 12;
}

/**
 * Get the DDD entry for a given code
 */
export function getDDDByCode(code: string): DDDEntry | undefined {
  return BRAZIL_DDDS.find((d) => d.code === code);
}